import Icon from "@components/ui/Icon";
import { Paragraph } from "@components/ui/Paragraph";
import { Title } from "@components/ui/Title";
import { TourByIdQuery } from "@graphql/types";
import { Trans } from "@helpers/translate";
import React, { FC } from "react";

interface Props {
  tour: NonNullable<TourByIdQuery["tourById"]>;
}

export const Inclusions: FC<Props> = ({ tour }) => {
  return (
    <div className="mb-20">
      <Title as="h2" size="md" divider>
        <Trans id="tour.block.inclusions.title">Inclusions & Exclusions</Trans>
      </Title>
      <div className="flex mb-6">
        <div className="w-8">
          <Icon icon="checkCircle" className="text-green-800" size="sm" />
        </div>
        <div className="w-full leading-relaxed">
          <div className="font-bold text-lg -mt-0.5">
            <Trans id="tour.block.inclusions.included">What‘s included</Trans>
          </div>
          <Paragraph size="md">{tour.included}</Paragraph>
        </div>
      </div>
      <div className="flex">
        <div className="w-8">
          <Icon icon="closeCircle" className="text-red-800" size="sm" />
        </div>
        <div className="w-full leading-relaxed">
          <div className="font-bold text-lg -mt-0.5">
            <Trans id="tour.block.inclusions.excluded">
              What‘s not included
            </Trans>
          </div>
          <Paragraph size="md">{tour.notIncluded}</Paragraph>
        </div>
      </div>
    </div>
  );
};
